import { ChevronDown, ChevronUp } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ReorderButtonsProps {
  /** The row's own name. Both buttons are labelled from it for screen readers. */
  label: string;
  onMove: (direction: "up" | "down") => void;
  /** True on the first row — and while a move is in flight. */
  disableUp: boolean;
  /** True on the last row — and while a move is in flight. */
  disableDown: boolean;
}

/**
 * The up/down pair in the Order column of a Settings → Config list. Seven of
 * them had their own copy, which is how the eighth (role levels) ended up with
 * a different icon and size without anyone noticing.
 *
 * Which rows get arrows at all is the caller's call: a retired row is pinned to
 * the bottom by the API's ordering, so its position means nothing and those
 * pages render a dash instead — which is also what keeps every move an adjacent
 * swap rather than a swap with a hidden neighbour.
 */
export function ReorderButtons({ label, onMove, disableUp, disableDown }: ReorderButtonsProps) {
  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        aria-label={`Move ${label} up`}
        disabled={disableUp}
        onClick={() => onMove("up")}
      >
        <ChevronUp className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        aria-label={`Move ${label} down`}
        disabled={disableDown}
        onClick={() => onMove("down")}
      >
        <ChevronDown className="h-4 w-4" />
      </Button>
    </div>
  );
}
